import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { Icon } from '../../Icon/Icon.js';

var Column = function Column(_ref) {
  var cell = _ref.cell;

  var props = _extends({}, cell.getHeaderProps(), cell.getSortByToggleProps && cell.getSortByToggleProps({
    title: undefined
  }), {
    className: cn('yt-table__cell', cell.className, {
      'yt-table__cell__group': !!cell.columns,
      'yt-table__cell--disable-sort': cell.disableSorting,
      'yt-table__cell--align-left': cell.align === 'left',
      'yt-table__cell--align-right': cell.align === 'right'
    }),
    style: _extends({}, cell.style, {
      flex: cell.flex
    })
  });

  if (cell.isSorted) {
    props['aria-sort'] = cell.isSortedDesc ? 'descending' : 'ascending';
  }

  return React__default.createElement("div", Object.assign({}, props, {
    key: cell.id
  }), React__default.createElement("span", null, cell.render('Header')), cell.isSorted ? React__default.createElement(Icon, {
    name: cell.isSortedDesc ? 'chevron-down-solid' : 'chevron-up-solid'
  }) : null);
};

export { Column };
//# sourceMappingURL=renderColumn.js.map
